
import "./user.less";
import { Component, Prop, Watch, BaseMixins, $util } from "@/lib";
import ChangePasswordView from "./change-password.vue";

@Component({ components: { ChangePasswordView } })
export default class CurrentUser extends BaseMixins {
  name: string = "CurrentUser";
  @Prop({ type: String, default: "" }) userAvatar: string;
  @Prop({ type: Number, default: 0 }) messageUnreadCount: number;
  @Prop({ type: Boolean, default: false }) isShowAvator: boolean;
  @Prop({ type: String, default: "" }) userName: string;

  logout() {
    this.$store.commit("app/logout", this);
    $util.basic.utils.clearToken();
    // $util.basic.utils.deleteTenantIdCookie();
    location.reload();
  }

  changePassword() {
    (this.$refs["change-password-form"] as any).open();
  }
  message() {
    this.$router.push({
      name: "message_page",
    });
  }
  handleClick(name) {
    switch (name) {
      case "logout":
        this.logout();
        break;
      case "message":
        this.message();
        break;
      case "changePassword":
        this.changePassword();
        break;
    }
  }
}
